import { ITextValue } from '@/types/common';
import { getPropertyTypesForFilters } from '@/bundles/GroupFilters/consts/getPropertyTypesForFilters';

export const getPropertyUsesForFilters = (): ITextValue<string>[] => {
  const propertyTypes = getPropertyTypesForFilters();

  propertyTypes.splice(1, 0, { text: 'Flex', value: 'flex' })

  return propertyTypes;
}
